import React, { useContext, useEffect, useState } from 'react'
import {
    Box, Button, Typography, IconButton, CircularProgress,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper,
    Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Context from '../../context/Context';
import { Plus } from 'lucide-react';
import DeleteConfirm from '../../Common/DeleteConfirm';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import apiUrl from '../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';

const DisplayCancellationPolicy = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [cancellation, setCabcellation] = useState([])
    const [errors, setErrors] = useState('')
    const handleAddClick = () => {
        navigate('/create-edit-cancellation-policy');
    };
    const handleEditClick = (cancellation) => {
        navigate('/create-edit-cancellation-policy', { state: { cancellation } });
    };

    const getCancellations = async () => {
        try {
            const response = await axios.get(apiUrl + `/cancellation/policies`)
            if (response?.data?.status === true) {
                setCabcellation(response?.data?.policies)
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error for getting ")
        }
    }

    const handleDelete = async () => {
        setIsConfirmDeleteModelOpen(false)
        setLoading(true)
        try {
            const response = await axios.delete(`${apiUrl}/cancellation/policies/${itemIdToDelete}`);
            if (response?.data?.status === true) {
                toast.success(response?.data?.message || "Cancellation deleted successfully")
                getCancellations()
            }
        } catch (error) {
            setErrors(error?.response?.data?.message || "Error for deleting ")
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        getCancellations()
    }, [])
    return (
        <>
            <Box sx={{ backgroundColor: "", padding: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h3">Cancellation policy</Typography>
                    <Button
                        variant="contained"
                        sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
                        onClick={handleAddClick}
                    >
                        <Plus size={23} />
                        <Typography>Add Cancellation</Typography>
                    </Button>
                </Box>

                <Divider sx={{ marginBottom: 3 }} />
                <Box >
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100px">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <TableContainer component={Paper} elevation={1}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>S.NO</strong></TableCell>
                                        <TableCell><strong>HoursFrom</strong></TableCell>
                                        <TableCell><strong>Hours To</strong></TableCell>
                                        <TableCell><strong>
                                            refund Percentage</strong></TableCell>

                                        <TableCell align='right'><strong>Actions</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {cancellation?.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">
                                                No cancellation found.
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        cancellation?.map((cancellation, index) => (
                                            <TableRow key={cancellation?.id}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{cancellation?.hoursFrom}</TableCell>
                                                <TableCell>
                                                    {cancellation?.hoursTo}
                                                </TableCell>
                                                <TableCell>{cancellation?.refundPercentage}</TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                                                        <IconButton onClick={() => handleEditClick(cancellation)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton color="error" onClick={() => confirmDelete(cancellation.id)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    {errors && <Typography variant='body2' color='error'>{errors}</Typography>}

                    <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
                </Box>
            </Box>
        </>
    )
}

export default DisplayCancellationPolicy